export const GET_POS_DATA_FETCH = 'GET_POS_DATA_FETCH';
export const GET_POS_DATA_FETCHING = 'GET_POS_DATA_FETCHING';
export const GET_POS_DATA_ERROR = 'GET_POS_DATA_ERROR';

export const WRITE_TRANSACTION_FETCH = 'WRITE_TRANSACTION_FETCH';
export const WRITE_TRANSACTION_FETCHING = 'WRITE_TRANSACTION_FETCHING';
export const WRITE_TRANSACTION_FETCH_ERROR = 'WRITE_TRANSACTION_FETCH_ERROR';

export const WRITE_TRANSACTION_LOCAL = 'WRITE_TRANSACTION_LOCAL';
export const DELETE_TRANSACTION_LOCAL = 'DELETE_TRANSACTION_LOCAL';

export const WRITE_LOCAL_ERROR = 'WRITE_LOCAL_ERROR';
export const RESET_WRITE_LOCAL_ERROR = 'RESET_WRITE_LOCAL_ERROR';

export const UPDATE_CURRENT_TRANSACTION = 'UPDATE_CURRENT_TRANSACTION';

export const UPDATE_CURRENT_TRANSACTION_ITEM_QUANTITY =
  'UPDATE_CURRENT_TRANSACTION_ITEM_QUANTITY';
export const UPDATE_CURRENT_TRANSACTION_REMOVE_ITEM =
  'UPDATE_CURRENT_TRANSACTION_REMOVE_ITEM';
export const UPDATE_CURRENT_TRANSACTION_AMOUNT_PAID =
  'UPDATE_CURRENT_TRANSACTION_AMOUNT_PAID';
export const UPDATE_CURRENT_TRANSACTION_UPDATE_CHECK_NUMBER =
  'UPDATE_CURRENT_TRANSACTION_UPDATE_CHECK_NUMBER';
export const RESET_CURRENT_TRANSACTION = 'RESET_CURRENT_TRANSACTION';
export const UPDATE_CURRENT_TRANSACTION_STUDENT_ID_SEED =
  'UPDATE_CURRENT_TRANSACTION_STUDENT_ID_SEED';
export const GET_STUDENT_TRANSACTION_HISTORY_FETCHING =
  'GET_STUDENT_TRANSACTION_HISTORY_FETCHING';
export const GET_STUDENT_TRANSACTION_HISTORY =
  'GET_STUDENT_TRANSACTION_HISTORY';
export const GET_STUDENT_TRANSACTION_HISTORY_ERROR =
  'GET_STUDENT_TRANSACTION_HISTORY_ERROR';
export const SET_VIEW_CURRENT_STUDENT_HISTORY =
  'SET_VIEW_CURRENT_STUDENT_HISTORY';

export const UPDATE_STUDENT = 'UPDATE_STUDENT';
export const FETCH_STUDENT = 'FETCH_STUDENT';
export const FETCH_STUDENT_ERROR = 'FETCH_STUDENT_ERROR';

export const SET_KEYPAD_READING_LEFT = 'SET_KEYPAD_READING_LEFT';
export const SET_KEYPAD_READING_RIGHT = 'SET_KEYPAD_READING_RIGHT';

export const MOVE_ITEM = 'MOVE_ITEM';

export const POS_SET_SITES = 'POS_SET_SITES';



// WEBPACK FOOTER //
// ./src/pages/pointofsale/state/types.js